<template>
  <div class="cell" @click="onClick">
    <div class="cell_left">
      <img :src="cellData.trial|playerOrLock" alt="" class="player">
      <div class="cell_content">
        <p class="title">
          <span class="name">{{cellData.name}}</span>
          <span class="audition" v-if="cellData.trial">试听</span>
        </p>
        <p class="sub_title">{{cellData.length|timeFilter}}</p>
      </div>
    </div>
    <img src="/images/omit.png" alt="">
  </div>
</template>
<script>
import { durationFormat } from "@/utils/filter";

export default {
  props: {
    cellData: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {}
  },
  filters: {
    playerOrLock (params) {
      return params ? '/images/study_player.png' : '/images/study_lock.png'
    },
    timeFilter(length) {
      return durationFormat(length);
    }
  },
  created(){},
  methods: {
    onClick () {
      this.$emit('toListen', {trial: this.cellData.trial, mediaId: this.cellData.id})
    }
  }
}
</script>

<style scoped>
.cell{
  height: 67px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #F0FEFF;
}

.cell_left{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.cell:last-of-type{
  border-bottom: none;
}
.cell .player{
  height: 24px;
  width: 24px;
  margin-right: 10px;
}
.cell .cell_content{
  display: inline-block;
}

.cell_content .title {
  height:22px;
  font-size:16px;
  font-weight:bold;
  color:rgba(102,102,102,1);
  margin-bottom: 4px;
  display: flex;
  align-items: center;
}
.cell_content .title .name{
  display: inline-block;
  max-width: 170px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.cell_content .title .audition{
  margin-left: 9px;
  display: inline-block;
  padding: 2px 7px 0;
  height:17px;
  line-height:17px;
  text-align: center;
  background:#ebf3fe;
  border-radius:6px;
  color: #3F8DFD;
  font-size:12px;
}
.cell_content .sub_title{
  height:17px;
  font-size:12px;
  font-weight:500;
  color:rgba(153,153,153,1);
  line-height:17px;
  max-width: 200px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
